import { CategoryName, resolveButtonedName } from '@infotech-soe/metaschema';

export type ResolvedFieldFromPath = {
  category: CategoryName;
  path: string;
  isRef: boolean;
  isSame: boolean;
};

export const resolve = (
  iPath: string,
  iCategory: CategoryName
): ResolvedFieldFromPath => {
  const { category: sCategory, name: sPath } = resolveButtonedName(iPath);

  if (!sPath.length) {
    throw new Error(`err in category field: ${iCategory}/${iPath}`);
  }

  return {
    category: sCategory ?? iCategory,
    path: sPath,
    isRef: !!sCategory,
    isSame: sCategory === iCategory,
  };
};
